import React from "react";

// ✅ 1. Accept the prop
const SharePointMockup = ({ onRoleSelect }) => {
  
  // Helper for hover effects (inline styles)
  const cardStyle = {
    background: "white", 
    padding: "1.5rem", 
    borderRadius: "4px", 
    boxShadow: "0 1.6px 3.6px 0 rgba(0,0,0,0.132), 0 0.3px 0.9px 0 rgba(0,0,0,0.108)", 
    cursor: "pointer", // Hand cursor
    transition: "transform 0.2s"
  };

  return (
    <div style={{
      fontFamily: '"Segoe UI", "Helvetica Neue", sans-serif',
      background: "#f3f2f1",
      border: "1px solid #e1dfdd",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 10px 30px rgba(0,0,0,0.15)"
    }}>
      
      {/* ... (Keep Top Nav and Hero Section exactly as they were) ... */}
      
      {/* 1. SHAREPOINT TOP NAV */}
      <div style={{ background: "#0078d4", padding: "0.75rem 1.5rem", display: "flex", justifyContent: "space-between", alignItems: "center", color: "white" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2px" }}>
            {[1,2,3,4,5,6,7,8,9].map(i => <div key={i} style={{ width: "4px", height: "4px", background: "white" }}></div>)}
          </div>
          <span style={{ fontWeight: "600", fontSize: "1.1rem" }}>SharePoint</span>
          <span style={{ opacity: 0.8, fontWeight: "300", borderLeft: "1px solid rgba(255,255,255,0.3)", paddingLeft: "1rem" }}>ACME Sales Academy</span>
        </div>
        <div style={{ display: "flex", gap: "1rem", fontSize: "0.9rem" }}>
          <span>Search sites...</span>
          <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>JD</div>
        </div>
      </div>

      {/* 2. HERO SECTION */}
      <div style={{ background: "white", padding: "2rem 3rem", borderBottom: "1px solid #e1dfdd" }}>
        <h4 style={{ color: "#605e5c", margin: "0 0 0.5rem 0", textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "1px" }}>Global Enablement Hub</h4>
        <h1 style={{ margin: "0", color: "#201f1e", fontSize: "2rem" }}>Select Your Role Journey</h1>
        <p style={{ color: "#605e5c", maxWidth: "600px", marginTop: "0.5rem" }}>
          Welcome to the new role-based curriculum. Select your track below to access your learning path, track your certification status, and view your solvency score.
        </p>
      </div>

      {/* 3. THE ROLE SELECTOR (Updated with Click Handlers) */}
      <div style={{ padding: "2rem 3rem", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "1.5rem" }}>
        
        {/* Card 1: AE */}
        <div 
          onClick={() => onRoleSelect('AE')}
          style={{ ...cardStyle, borderTop: "4px solid #7C3AED" }}
          onMouseEnter={e => e.currentTarget.style.transform = "translateY(-5px)"}
          onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
        >
          <h3 style={{ margin: "0 0 0.5rem 0", color: "#201f1e" }}>Account Executive</h3>
          <p style={{ fontSize: "0.85rem", color: "#605e5c", margin: "0 0 1.5rem 0" }}>Master the Commercial Value Prop and Pricing Negotiation.</p>
          <div style={{ height: "6px", background: "#e1dfdd", borderRadius: "3px", marginBottom: "0.5rem" }}>
            <div style={{ width: "35%", height: "100%", background: "#7C3AED", borderRadius: "3px" }}></div>
          </div>
          <div style={{ fontSize: "0.75rem", color: "#605e5c", display: "flex", justifyContent: "space-between" }}>
            <span>Progress</span>
            <span>35%</span>
          </div>
        </div>

        {/* Card 2: PS */}
        <div 
          onClick={() => onRoleSelect('PS')}
          style={{ ...cardStyle, borderTop: "4px solid #0078d4" }}
          onMouseEnter={e => e.currentTarget.style.transform = "translateY(-5px)"}
          onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
        >
          <h3 style={{ margin: "0 0 0.5rem 0", color: "#201f1e" }}>Product Specialist</h3>
          <p style={{ fontSize: "0.85rem", color: "#605e5c", margin: "0 0 1.5rem 0" }}>Deep dive into Data Ingestion, APIs, and Technical Specs.</p>
          <div style={{ height: "6px", background: "#e1dfdd", borderRadius: "3px", marginBottom: "0.5rem" }}>
            <div style={{ width: "10%", height: "100%", background: "#0078d4", borderRadius: "3px" }}></div>
          </div>
          <div style={{ fontSize: "0.75rem", color: "#605e5c", display: "flex", justifyContent: "space-between" }}>
            <span>Progress</span>
            <span>10%</span>
          </div>
        </div>

        {/* Card 3: CSM */}
        <div 
          onClick={() => onRoleSelect('CSM')}
          style={{ ...cardStyle, borderTop: "4px solid #107c10" }}
          onMouseEnter={e => e.currentTarget.style.transform = "translateY(-5px)"}
          onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
        >
          <h3 style={{ margin: "0 0 0.5rem 0", color: "#201f1e" }}>Customer Success</h3>
          <p style={{ fontSize: "0.85rem", color: "#605e5c", margin: "0 0 1.5rem 0" }}>Focus on Adoption, Marketing Use Cases, and Renewal Defense.</p>
          <div style={{ height: "6px", background: "#e1dfdd", borderRadius: "3px", marginBottom: "0.5rem" }}>
            <div style={{ width: "0%", height: "100%", background: "#107c10", borderRadius: "3px" }}></div>
          </div>
          <div style={{ fontSize: "0.75rem", color: "#605e5c", display: "flex", justifyContent: "space-between" }}>
            <span>Progress</span>
            <span>0%</span>
          </div>
        </div>
      </div>

      {/* ... (Keep Certification & Metrics Section as is) ... */}
      {/* 4. CERTIFICATION & METRICS */}
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: "2rem", padding: "0 3rem 3rem" }}>
        
        {/* Left: Certification Path */}
        <div style={{ background: "white", padding: "1.5rem", borderRadius: "4px", border: "1px solid #e1dfdd" }}>
          <h4 style={{ margin: "0 0 1rem 0", color: "#201f1e" }}>Your Certification Requirements</h4>
          <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1rem" }}>
            <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: "#dff6dd", color: "#107c10", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold" }}>✓</div>
            <div>
              <div style={{ fontWeight: "600", fontSize: "0.9rem" }}>Phase 1: Universal Core</div>
              <div style={{ fontSize: "0.8rem", color: "#605e5c" }}>Completed Jan 15</div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1rem" }}>
             <div style={{ width: "32px", height: "32px", borderRadius: "50%", border: "2px dashed #0078d4", color: "#0078d4", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold" }}>2</div>
            <div>
              <div style={{ fontWeight: "600", fontSize: "0.9rem" }}>Phase 2: Role Specialization</div>
              <div style={{ fontSize: "0.8rem", color: "#605e5c" }}>In Progress - Complete 3 Modules</div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
             <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: "#f3f2f1", color: "#a19f9d", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold" }}>🔒</div>
            <div>
              <div style={{ fontWeight: "600", fontSize: "0.9rem", color: "#a19f9d" }}>Phase 3: Stand & Deliver</div>
              <div style={{ fontSize: "0.8rem", color: "#a19f9d" }}>Locked - Requires Phase 2 Completion</div>
            </div>
          </div>
        </div>

        {/* Right: Impact Metrics */}
        <div style={{ background: "white", padding: "1.5rem", borderRadius: "4px", border: "1px solid #e1dfdd" }}>
           <h4 style={{ margin: "0 0 1rem 0", color: "#201f1e" }}>My Impact Score</h4>
           <div style={{ textAlign: "center", padding: "1rem 0" }}>
              <div style={{ fontSize: "3rem", fontWeight: "700", color: "#0078d4", lineHeight: "1" }}>—</div>
              <div style={{ fontSize: "0.85rem", color: "#605e5c", marginTop: "0.5rem" }}>Solvency Score</div>
           </div>
           <div style={{ fontSize: "0.8rem", color: "#605e5c", lineHeight: "1.4" }}>
             Your score will calculate based on <strong>Quiz Accuracy</strong> + <strong>Pitch Score</strong> + <strong>Pipeline Creation</strong> post-certification.
           </div>
        </div>

      </div>

    </div>
  );
};

export default SharePointMockup;
